/**
 * Root Route
 * @description TanStack Router root route, 경로별 realm 동기화
 */

import { createRootRoute, Outlet, useLocation } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  const location = useLocation();
  const initialize = useAuthStore((state) => state.initialize);

  // 경로 변경 시 해당 영역(Tenant/Admin) 저장소에서 사용자 복원
  useEffect(() => {
    initialize(location.pathname);
  }, [location.pathname, initialize]);

  return <Outlet />;
}
